export default [
    {
        path: '/disciplinary-actions',
        name: 'disciplinary',
        meta: { requiresAuth: true },
        component: () => import('@/pages/disciplinary-action/index.vue')
    },
    {
        path: '/disciplinary-actions/create',
        name: 'disciplinary-create',
        meta: { requiresAuth: true },
        component: () => import('@/pages/disciplinary-action/create.vue')
    },
]
